export var Tabs;
(function (Tabs) {
    Tabs[Tabs["FlightInfo"] = 0] = "FlightInfo";
    Tabs[Tabs["EconomyFares"] = 1] = "EconomyFares";
    Tabs[Tabs["BusinessFares"] = 2] = "BusinessFares";
    Tabs[Tabs["MilesFares"] = 3] = "MilesFares";
})(Tabs || (Tabs = {}));
